/**
 * OppositionsListView — aba "Oposições" do Centro de Direitos (LGPD Art. 18 §2).
 *
 * Oposição ao tratamento flui no backend como `LgpdRequestType=opposition` pela
 * pipeline LGPD existente. Esta aba **reusa** o `LgpdRequestsListView` travado
 * em `opposition` (sem duplicar backend), com filtro de status próprio e o
 * mesmo drawer de detalhe da aba Solicitações (via `onOpenDetail`).
 */

import { useState } from 'react';

import { useLgpdRequests } from '../../../hooks/use-lgpd-requests';

import { LgpdRequestsListView } from './LgpdRequestsListView';

import type { LgpdRequestStatus, LgpdRequestWireItem } from './types';

export function OppositionsListView({
  onOpenDetail,
}: {
  onOpenDetail: (request: LgpdRequestWireItem) => void;
}): JSX.Element {
  const [filterStatus, setFilterStatus] = useState<LgpdRequestStatus | 'all'>('all');
  const statusFilter = filterStatus === 'all' ? undefined : filterStatus;

  const { data, isLoading, isError } = useLgpdRequests({
    requestType: 'opposition',
    ...(statusFilter !== undefined ? { status: statusFilter } : {}),
  });

  return (
    <div>
      <p style={{ fontSize: 12, color: '#6b7280', margin: '0 0 12px' }}>
        Oposições ao tratamento de dados (Art. 18, §2º) registradas pelo titular. Detalhe e resposta
        no mesmo fluxo das demais solicitações LGPD.
      </p>
      <LgpdRequestsListView
        requests={data}
        isLoading={isLoading}
        isError={isError}
        filterStatus={filterStatus}
        filterType="opposition"
        onFilterStatusChange={setFilterStatus}
        onFilterTypeChange={() => {
          /* tipo travado em 'opposition' nesta aba */
        }}
        onOpenDetail={onOpenDetail}
        lockedType="opposition"
      />
    </div>
  );
}
